export default __webpack_public_path__ + "static/Roobert-Regular-ccd5598260c0a11df7415ab3dda011d0.woff";